export default "__VITE_ASSET__CihbGpek__"